import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer"
import dashboardReducer from "./reducer/dashboard/DashboardReducer"
import masterReducer from "./reducer/master/masterReducer"
import settingsReducer from "./reducer/settings/settingsReducer"
import usersReducer from "./reducer/users/usersReducer"
import vendorReducer from "./reducer/vendor/vendorReducer"
import subscriptionReducer from "./reducer/subscription/subscriptionReducer"
import shopReducer from "./reducer/shop/shopReducer"

const rootReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...dashboardReducer,
    ...masterReducer,
    ...settingsReducer,
    ...usersReducer,
    ...vendorReducer,
    ...subscriptionReducer,
    ...shopReducer,
});

const alexa_farm_store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default alexa_farm_store;